import React, {Component, createRef} from "react";
import {NavigateFunction} from "react-router-dom";
import OrderSummary from "../OrderSummary/OrderSummary";
import {Button, ButtonGroup, Container, Divider, Grid, Header, Input, Modal, Ref, Sticky,} from "semantic-ui-react";
import {IProduct, IProductState, IVariant} from "../../models/product.interface";
import {connect} from "react-redux";
import {Basket} from "../../models/basket.model";
import {basketActions} from "../../redux/actions/basket.actions";
import {Property} from "../../models/property.model";
import {propertiesActions} from "../../redux/actions/properties.actions";
import {Product} from "../../models/product.model";
import {IPolicyResponse} from "../../models/policy-response.interface";

import {IStoreState} from "../../redux/reducers/root.reducer";
import {ProductContainer} from "../Product/ProductContainer";
import _ from "lodash";
import Wizard from "../Wizard/Wizard";
import ToolTip from "../shared/ToolTip";

import AddressSelector, {DisplayMode, EditMode} from "../AddressSelector/AddressSelector";
import {Address} from "../AddressSelector/Address"
import {Country} from "../CountrySelector/Country";

import {addressLookupURL} from "../../index";
import {PartialPolicy, Policy} from "../../models/policy.model";
import {IUtm} from "../../models/utm.interface";
import {policyActions} from "../../redux/actions/policy.actions";

interface IPropertyAndCoverProps {
    addToBasket(basket: Basket, property: Property, product: Product): void;

    removeFromBasket(basket: Basket, property: Property, product: Product): void;

    addProperty(property: Property): void;

    basket: Basket;
    startDate: string;
    products: IProductState | null;

    updateBasket(basket: Basket, property: Property): void;

    navigate: NavigateFunction;

    createPolicy(partialPolicy: PartialPolicy, utm: IUtm): number;

    email?: string;
    agentCode?: string;
    phone?: string;
    utm?: IUtm | null;
    policyResponse: IPolicyResponse | null;
    address: Address;
}

interface IState {
    partialPolicy: PartialPolicy;
    policy: Policy;
    policyId: number;
    products: Array<Product>;
    properties: Array<Property>;
    address: Address;
    preEditAddress: Address;
    addressSelected: boolean;
    editingAddress: boolean;
    showFlatsCountQuestion: boolean;
    showTenancyCountQuestion: boolean;
    showFlatsQuestion: boolean;
    showProducts: boolean;
    flatsCount: number;
    tenancyCount: number;
    hiddenCss: {};
    showHmoQuestion: boolean;
    showProductsContainer: boolean;
    isHmo: boolean | null;
    isFlats: boolean | null;
    showExclusivityGroupModal: boolean;
    relatedExclusivityProduct: IProduct | null;
    exclusivityProductToAdd: IProduct | null;
    exclusivityVariantToAdd: IVariant | null;
    currentProperty: number;
    showDebug: boolean;
}

export class _PropertyAndCover extends Component<IPropertyAndCoverProps, IState> {
    contextRef = createRef();
    stickyRef = createRef<HTMLElement>();

    state: IState = {
        partialPolicy: new PartialPolicy(),
        policy: new Policy(),
        products: new Array<Product>(),
        properties: new Array<Property>(),
        address: new Address(),
        preEditAddress: new Address(),
        addressSelected: false,
        editingAddress: false,
        showFlatsCountQuestion: false,
        showTenancyCountQuestion: false,
        showFlatsQuestion: false,
        showHmoQuestion: false,
        isHmo: null,
        isFlats: null,
        policyId: 0,
        flatsCount: 1,
        tenancyCount: 1,
        hiddenCss: {display: "none"},
        showProducts: false,
        showProductsContainer: false,
        showExclusivityGroupModal: false,
        relatedExclusivityProduct: null,
        exclusivityProductToAdd: null,
        exclusivityVariantToAdd: null,
        currentProperty: 1,
        showDebug: false
    };

    addressSelectorRef = React.createRef<AddressSelector>();


    constructor(props: IPropertyAndCoverProps) {
        super(props);

        this.state.partialPolicy.email = this.props.email ? this.props.email : "";

        if (this.state.showDebug) {
            console.log("PropertyAndCover::Constructor:Props", this.props);
            console.log("PropertyAndCover::Constructor:State", this.state);
            console.log("PropertyAndCover::Constructor:State->Address", this.state.address);
        }
        //this.state.address = this.props.address ? this.props.address : new Address();
        //this.state.preEditAddress = this.props.address ? this.props.address : new Address();


        this.state.partialPolicy.phone = this.props.phone ? this.props.phone : "";

        this.state.partialPolicy.phoneCountryCode = "44";


        this.state.properties = this.props.basket.properties ? this.props.basket.properties : new Array<Property>();
        if (this.props.basket.properties.length > 0) {
            const selectedProperty = this.props.basket.properties[0];

            if (this.state.showDebug) {
                console.log("PropertyAndCover::Constructor:Selected Property", selectedProperty);
            }
            this.state.address = selectedProperty.address;
            this.state.showHmoQuestion = true;
            this.state.showTenancyCountQuestion = selectedProperty.tenancyCount > 1;
            this.state.showFlatsQuestion = selectedProperty.tenancyCount < 2;
            this.state.showFlatsCountQuestion = selectedProperty.numberOfFlats > 1;
            this.state.isHmo = selectedProperty.tenancyCount > 1;
            this.state.isFlats = selectedProperty.numberOfFlats > 1;
            this.state.tenancyCount = selectedProperty.tenancyCount;
            this.state.flatsCount = selectedProperty.numberOfFlats;
            this.state.showProductsContainer = true;

        }

    }

    getSnapshotBeforeUpdate(prevProps: IPropertyAndCoverProps, prevState: IState) {
        return null;
    }

    componentDidUpdate(prevProps: IPropertyAndCoverProps, prevState: IState, snapshot: any) {
        if (this.state.showDebug) {
            console.log("PropertyAndCover::ComponentDidUpdate:PrevProps", prevProps);
            console.log("PropertyAndCover::ComponentDidUpdate:Props", this.props);

            console.log("PropertyAndCover::ComponentDidUpdate:PrevState", prevState);
            console.log("PropertyAndCover::ComponentDidUpdate:State", this.state);
        }

        if (this.props.policyResponse === null) return;

        if (this.props.policyResponse !== prevProps.policyResponse) {

            let policyId = this.props.policyResponse.id;

            if (policyId > 0) {

                this.setState({policyId: this.props.policyResponse.id}, () => {
                    if (this.props.policyResponse != null && prevProps.policyResponse != null && this.props.policyResponse.failed && this.props.policyResponse.failed !== prevProps.policyResponse.failed) {

                        if (this.state.showDebug) {
                            console.log("Policy creation failed", policyId)
                        }
                        //this.setState({failed: true});
                    } else {
                        if (this.state.showDebug) {
                            console.log("Policy creation succeeded", policyId);
                        }

                        this.props.navigate("/checkout", {replace: true});
                    }
                });

            }
        }

        if (this.state.address != prevState.address && this.state.address.address1 && this.state.address.address1.length > 0) {
            if (this.state.showDebug) {
                console.log("PropertyAndCover::ComponentDidUpdate::Address in State changed");
            }

            this.addressSelectorRef.current?.manuallySetAddress(this.state.address);

        }

    }

    showProductsContainer = () => {
        // console.log(this.state);
        if (this.state.isHmo !== null && !this.state.isHmo && this.state.isFlats !== null && !this.state.isFlats) {
            this.setState({showProductsContainer: true});
        }
        if (this.state.isHmo && this.state.tenancyCount > 0) this.setState({showProductsContainer: true});

        if (this.state.isFlats && this.state.flatsCount > 0) this.setState({showProductsContainer: true});
    };

    removeProductFromProperty = async (product: IProduct) => {
        let propertyIndex = this.getSelectedPropertyIndex();

        let properties = this.state.properties;

        let property = properties[propertyIndex];

        let productIndex = this.getPropertyProductIndex(property, product);

        if (productIndex > -1) {
            let selectedProductToRemove = property.products[productIndex];

            _.remove(property.products, (p) => {
                return p.productCode === selectedProductToRemove.productCode;
            });

            await this.setState({properties: properties});
            //console.log(this.state);
        }
    };

    onTenancyCountChange = () => {
        let propertyIndex = this.getSelectedPropertyIndex();

        if (propertyIndex > -1) {
            this.updateProperty().then(() => {
                this.props.updateBasket(this.props.basket, this.state.properties[propertyIndex]);
            });
        }
    };

    onFlatsCountChange = () => {
        let propertyIndex = this.getSelectedPropertyIndex();

        if (propertyIndex > -1) {
            this.updateProperty().then(() => {
                this.props.updateBasket(this.props.basket, this.state.properties[propertyIndex]);
            });
        }
    };

    updateProperty = async () => {
        let propertyIndex = this.getSelectedPropertyIndex();

        let properties = this.state.properties;

        let property = properties[propertyIndex];

        property.tenancyCount = this.state.tenancyCount;
        property.numberOfFlats = this.state.flatsCount;

        await this.setState({properties: properties});
    };

    getPropertyKey = (address: Address): string => {
        return (address.address1 + address.postCode).replace(/\s/g, "");
    };

    getSelectedPropertyIndex = (): number => {
        let key = this.getPropertyKey(this.state.address);
        // console.log(key);
        return _.findIndex(this.state.properties, {
            key: key,
        });
    };

    getPropertyIndex = (key: string): number => {
        return _.findIndex(this.state.properties, {
            key: key,
        });
    };

    getSelectedProperty = (): Property => {
        let propertyIndex = this.getSelectedPropertyIndex();

        return this.state.properties[propertyIndex];
    };

    getPropertyByKey = (key: string): Property => {
        let propertyIndex = this.getPropertyIndex(key);

        return this.state.properties[propertyIndex];
    };

    getPropertyProductIndex = (property: Property, product: IProduct): number => {
        return _.findIndex(property.products, {
            exclusivityGroup: product.exclusivityGroup,
        });
    };

    renderExclusitivityGroupCheckModal = () => {
        return (
            <Modal
                size="mini"
                open={this.state.showExclusivityGroupModal}
                onClose={async () => {
                    await this.setState({showExclusivityGroupModal: false});
                }}>
                <Modal.Content>
                    <p>
                        Adding this cover will remove &nbsp;
                        {this.state.relatedExclusivityProduct ? this.state.relatedExclusivityProduct.productDisplayName : ""}
                        &nbsp; from your basket
                    </p>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        onClick={async () => {
                            await this.setState({showExclusivityGroupModal: false});
                        }}>
                        Cancel
                    </Button>
                    <Button
                        positive
                        onClick={async () => {
                            if (this.state.relatedExclusivityProduct) {
                                //Remove the product in the same exclusitivity group

                                let property = this.getSelectedProperty();

                                await this.onRemoveFromBasket(property, this.state.relatedExclusivityProduct);

                                //Add the new product
                                if (this.state.exclusivityProductToAdd && this.state.exclusivityVariantToAdd) {
                                    await this.onAddToBasket(this.state.exclusivityProductToAdd, this.state.exclusivityVariantToAdd);
                                }

                                await this.setState({showExclusivityGroupModal: false});
                            }
                        }}>
                        Add to basket
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    };

    isProductSelected = (productCode: string) => {
        let propertyIndex = this.getSelectedPropertyIndex();

        if (propertyIndex > -1) {
            let productIndex = _.findIndex(this.state.properties[propertyIndex].products, {productCode: productCode});

            return productIndex >= 0;
        }

        return false;
    };

    renderProductsContainer = () => {
        if (this.props.products !== null) {
            let key = 0;
            return (
                <div>
                    <Header as="h2" className="secondBlockHeader">
                        Now choose the cover you need{(this.state.currentProperty > 1 ? " for property " + _.padStart(this.state.currentProperty.toString(), 2, ' ') : "")}
                    </Header>
                    {this.props.products.products.map((product) => (
                        <div key={key++}>
                            <ProductContainer
                                isProductSelected={this.isProductSelected(product.productCode)}
                                product={product}
                                products={(this.props.products && this.props.products.products) || []}
                                onAddToBasket={async (product: IProduct, variant: IVariant) => {
                                    //Check Exclusivity Group

                                    let productIndex = -1;

                                    let propertyIndex = this.getSelectedPropertyIndex();

                                    if (propertyIndex !== -1) {
                                        productIndex = this.getPropertyProductIndex(this.state.properties[propertyIndex], product);
                                    }

                                    if (productIndex === -1) {
                                        await this.onAddToBasket(product, variant);
                                    } else {
                                        let relatedProduct = _.find(this.props.products && this.props.products.products, {
                                            productCode: this.state.properties[propertyIndex].products[productIndex].productCode,
                                        });

                                        await this.setState({
                                            exclusivityProductToAdd: product,
                                            exclusivityVariantToAdd: variant,
                                            showExclusivityGroupModal: true,
                                            relatedExclusivityProduct: relatedProduct === undefined ? null : relatedProduct
                                        });
                                    }
                                }}
                                onRemoveFromBasket={async (product: IProduct) => {
                                    let property = this.getSelectedProperty();
                                    await this.onRemoveFromBasket(property, product);
                                    //this.removeProductFromProperty(product);
                                }}
                                isProductInSameExlusivityGroup={false}/>
                            <Divider hidden/>
                        </div>
                    ))}
                </div>
            );
        } else {
            return <div>No Products</div>;
        }
    };

    handleAddressClear = () => {
        this.setState({address: new Address()});
    };

    validateAddress = () => {
        if (!this.addressSelectorRef.current) return;

        this.addressSelectorRef.current.validate();
    };

    clearAddress = async () => {
        if (!this.addressSelectorRef.current) return;

        await this.addressSelectorRef.current.resetAddressSelection();
    };

    onAddToBasket = async (product: IProduct, variant: IVariant) => {
        let productToAdd = new Product();
        productToAdd.productCode = product.productCode;
        productToAdd.productDisplayName = product.productDisplayName;
        productToAdd.coverDurationMonths = variant.duration;
        productToAdd.ipt = variant.ipt;
        productToAdd.nett = variant.nett;
        productToAdd.rentalAmount = variant.rentalAmount;
        productToAdd.total = variant.total;
        productToAdd.exclusivityGroup = product.exclusivityGroup;

        let properties = this.state.properties;

        let propertyIndex = this.getSelectedPropertyIndex();

        let property: Property;

        if (propertyIndex === -1) {
            property = new Property();
            property.key = this.getPropertyKey(this.state.address);
            property.hmo = this.state.isHmo !== null ? this.state.isHmo : false;
            property.tenancyCount = this.state.tenancyCount;
            property.numberOfFlats = this.state.flatsCount;
            property.startDate = this.props.startDate;
            property.address = this.state.address;

            this.props.addToBasket(this.props.basket, property, productToAdd);

            await this.setState({
                properties: this.state.properties.concat(property),
            });
        } else {
            property = properties[propertyIndex];

            _.remove(properties, (p) => {
                return p.key === property.key;
            });

            this.props.addToBasket(this.props.basket, property, productToAdd);
            await this.setState({
                properties: this.state.properties.concat(property),
            });
        }
    };

    onRemoveFromBasket = async (property: Property, product: IProduct) => {
        let productToRemove = new Product();
        productToRemove.productCode = product.productCode;
        productToRemove.productDisplayName = product.productDisplayName;

        let properties = this.state.properties;
        let propertyIndex = this.getPropertyIndex(property.key);

        if (propertyIndex > -1 && properties[propertyIndex]) {

            let productIndex = this.getPropertyProductIndex(properties[propertyIndex], product);
            let p: Property = new Property();

            if (productIndex > -1) {
                // Remove product
                p = properties[propertyIndex];
                properties[propertyIndex].products.splice(productIndex, 1);
            }

            //Remove property if the property has no products
            properties = _.filter(properties, function (p) {
                return p.products.length !== 0;
            });

            this.props.removeFromBasket(this.props.basket, p, productToRemove);
            await this.setState({properties: properties});
        }
    };

    onStep = (step: number) => {
        if (step === 3) {
            this.props.navigate("/checkout");
        }
        if (step === 2) {
            this.props.navigate("/property-and-cover");
        }
        if (step === 1) {
            this.props.navigate("/start");
        }
    }

    render() {

        const rentalAddressLookupProps = {
            ref: this.addressSelectorRef,
            onReset: () => {
                //console.log("Address reset");
                this.setState({
                    address: new Address(),
                    addressSelected: false,
                    showProductsContainer: false,
                    showHmoQuestion: false,
                    showFlatsQuestion: false,
                    showFlatsCountQuestion: false,
                    showTenancyCountQuestion: false,
                })
            },
            onAddressSelect: (addressChosen: Address) => {
                //console.log("Address select", addressChosen);

                addressChosen.country = "United Kingdom";
                addressChosen.country2CharIsoCode = "GB";

                this.setState({address: addressChosen, showHmoQuestion: true, addressSelected: true});
            },
            onInvalidAddress: () => {
                if (this.state.showDebug) {
                    console.log("Invalid Address");
                }
                this.setState({
                    showProductsContainer: false,
                    showHmoQuestion: false,
                    showFlatsQuestion: false,
                    showFlatsCountQuestion: false,
                    showTenancyCountQuestion: false,
                });
            },
            onValidAddress: () => {
                // console.log("Valid Address");
                this.setState({
                    showHmoQuestion: true, addressSelected: true
                });
            },
            blockedPostCodeCallback: (searchTerm: string, postCodePrefixToBlock: string, msg: string) => {
            },
            onDisplayModeChange: (dm: DisplayMode) => {
                if (dm == DisplayMode.FormattedAddress) {
                    this.setState({
                        showHmoQuestion: true
                    });
                } else {
                    this.setState({
                        editingAddress: (dm == DisplayMode.SeparateAddressFields),
                        showHmoQuestion: false
                    });
                }
            },
            onCountryChange: (c: Country) => {
                //console.log("Country changed :" + c.englishShortName);
            },
            allowInternationalAddress: false,
            searchCountries: "GB",
            baseURL: addressLookupURL,
            alwaysShowCountryList: true,
            initialDisplayMode: DisplayMode.Lookup,
            editMode: EditMode.AllowChangeToAddressOnly,
            showDebug: this.state.showDebug,
            address: this.state.address
        };


        return (
            <>
                <Container>
                    <Wizard activeStep={2} maxActiveStep={1} onClick={this.onStep}/>
                    <Container className="contentWrapper">
                        <Grid stackable>
                            <Ref innerRef={this.stickyRef}>
                                <Grid.Row>
                                    <Grid.Column mobile={16} tablet={10} computer={10} className="propertyAddress">
                                        <Container className="b2c__card">
                                            <label>What is the address of rental property {(this.state.currentProperty > 1 ? _.padStart(this.state.currentProperty.toString(), 2, ' ') : "")}</label>
                                            <AddressSelector {...rentalAddressLookupProps} />
                                            <div style={!this.state.showHmoQuestion ? this.state.hiddenCss : {}}>
                                                <label>Is this property a House in Multiple Occupation (HMO)?</label>
                                                <Grid className="buttons-yes-no">
                                                    <Grid.Row>
                                                        <Grid.Column mobile={15} tablet={6} computer={6}>
                                                            <ButtonGroup>
                                                                <Button
                                                                    className={this.state.isHmo !== null && this.state.isHmo ? "active" : ""}
                                                                    onClick={(event: any) => {
                                                                        event.preventDefault();
                                                                        this.setState(
                                                                            {
                                                                                showFlatsQuestion: false,
                                                                                isHmo: true,
                                                                                showTenancyCountQuestion: true,
                                                                            },
                                                                            () => this.showProductsContainer()
                                                                        );
                                                                    }}>
                                                                    Yes
                                                                </Button>
                                                                <Button
                                                                    className={this.state.isHmo !== null && !this.state.isHmo ? "active" : ""}
                                                                    onClick={(event: any) => {
                                                                        event.preventDefault();
                                                                        this.setState(
                                                                            {
                                                                                showTenancyCountQuestion: false,
                                                                                tenancyCount: 1,
                                                                                showFlatsQuestion: true,
                                                                                isHmo: false,
                                                                            },
                                                                            () => {
                                                                                this.onTenancyCountChange();
                                                                                this.showProductsContainer();
                                                                            }
                                                                        );
                                                                    }}>
                                                                    No
                                                                </Button>
                                                            </ButtonGroup>
                                                        </Grid.Column>
                                                        <Grid.Column width={1}>
                                                            <ToolTip cssClasses="">
                              <span>
                                Your property is a house in multiple occupation (HMO) if both of the following apply: i) at least 3 tenants live there, forming
                                more than 1 household, and ii) those tenants share a toilet, bathroom or kitchen facilities with other tenants.
                              </span>
                                                            </ToolTip>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                            </div>
                                            <Divider hidden/>
                                            <div style={!this.state.showTenancyCountQuestion ? this.state.hiddenCss : {}}>
                                                <label>How many seperate tenancies in the property?</label>
                                                <Input
                                                    type="number"
                                                    min="1"
                                                    max="99"
                                                    onChange={(event: any) => {
                                                        const {value} = event.target;
                                                        let newValue = value.slice(0, 2);

                                                        let parsed = parseInt(newValue, 10);
                                                        if (isNaN(parsed)) {
                                                            parsed = 1;
                                                        }

                                                        this.setState(
                                                            {
                                                                tenancyCount: parsed,
                                                            },
                                                            () => {
                                                                this.onTenancyCountChange();
                                                                this.showProductsContainer();
                                                            }
                                                        );
                                                    }}
                                                    value={this.state.tenancyCount}/>
                                            </div>
                                            <div style={!this.state.showFlatsQuestion ? this.state.hiddenCss : {}}>
                                                <Divider hidden className="small"/>
                                                <label>Is this property a block of flats or converted into flats?<br/>
                                                    (Select no if you are only insuring a single flat)</label>
                                                <Grid className="buttons-yes-no">
                                                    <Grid.Row>
                                                        <Grid.Column mobile={15} tablet={6} computer={6}>
                                                            <ButtonGroup>
                                                                <Button
                                                                    className={this.state.isFlats !== null && this.state.isFlats ? "active" : ""}
                                                                    onClick={(event: any) => {
                                                                        event.preventDefault();
                                                                        this.setState(
                                                                            {
                                                                                showFlatsCountQuestion: true,
                                                                                isFlats: true,
                                                                            },
                                                                            () => this.showProductsContainer()
                                                                        );
                                                                    }}>
                                                                    Yes
                                                                </Button>
                                                                <Button
                                                                    className={this.state.isFlats !== null && !this.state.isFlats ? "active" : ""}
                                                                    onClick={(event: any) => {
                                                                        event.preventDefault();
                                                                        this.setState(
                                                                            {
                                                                                flatsCount: 1,
                                                                                showFlatsCountQuestion: false,
                                                                                isFlats: false,
                                                                            },
                                                                            () => {
                                                                                this.onFlatsCountChange();
                                                                                this.showProductsContainer();
                                                                            }
                                                                        );
                                                                    }}>
                                                                    No
                                                                </Button>
                                                            </ButtonGroup>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                                <Divider hidden/>
                                                <div style={!this.state.showFlatsCountQuestion ? this.state.hiddenCss : {}}>
                                                    <label>How many flats or units are in the property?</label>
                                                    <Grid className="buttons-yes-no">
                                                        <Grid.Row>
                                                            <Grid.Column mobile={15} tablet={6} computer={6}>
                                                                <Input
                                                                    type="number"
                                                                    min="1"
                                                                    max="99"
                                                                    onChange={(event: any) => {
                                                                        const {value} = event.target;
                                                                        let newValue = value.slice(0, 2);

                                                                        let parsed = parseInt(newValue, 10);
                                                                        if (isNaN(parsed)) {
                                                                            parsed = 1;
                                                                        }

                                                                        this.setState({flatsCount: parsed}, () => {
                                                                            this.onFlatsCountChange();
                                                                            this.showProductsContainer();
                                                                        });
                                                                    }}
                                                                    value={this.state.flatsCount}/>
                                                            </Grid.Column>
                                                        </Grid.Row>
                                                    </Grid>
                                                </div>
                                            </div>
                                        </Container>
                                        {this.state.showProductsContainer ? this.renderProductsContainer() : null}
                                    </Grid.Column>
                                    <Grid.Column mobile={16} tablet={6} computer={6} className="orderSummary">
                                        {/* Order summary */}
                                        <Sticky context={this.stickyRef} offset={20}>
                                            <OrderSummary
                                                {...this.props}
                                                onExpand={(isMaximized) => {
                                                    if (isMaximized)
                                                        document.body.style.overflow = "hidden";
                                                    else
                                                        document.body.style.overflow = "inherit"
                                                }}
                                                properties={this.props.basket.properties}
                                                onAddProperty={async () => {
                                                    await this.clearAddress();
                                                    await this.setState({address: new Address(), currentProperty: this.state.currentProperty + 1});
                                                    await this.setState({showFlatsCountQuestion: false});
                                                    await this.setState({showHmoQuestion: false});
                                                    await this.setState({
                                                        showTenancyCountQuestion: false,
                                                    });
                                                    await this.setState({showFlatsQuestion: false});
                                                    await this.setState({flatsCount: 1});
                                                    await this.setState({tenancyCount: 1});
                                                    await this.setState({isHmo: null});
                                                    await this.setState({isFlats: null});
                                                    await this.setState({showProductsContainer: false});
                                                }}
                                                onRemoveFromBasket={async (property: Property, product: Product) => {
                                                    let productToRemove = _.find(this.props.products && this.props.products.products, {
                                                        productCode: product.productCode,
                                                    });
                                                    if (productToRemove !== undefined) {
                                                        await this.onRemoveFromBasket(property, productToRemove);
                                                        //this.removeProductFromProperty(productToRemove);
                                                    }
                                                }}
                                                onPropertySelect={(index, selectedPropertyAddress) => {
                                                    let selectedPropertyKey = this.getPropertyKey(selectedPropertyAddress);

                                                    let selectedProperty = this.getPropertyByKey(selectedPropertyKey);

                                                    if (this.state.showDebug) {
                                                        console.log("PropertyAndCover::selectedProperty", selectedProperty);
                                                    }
                                                    this.setState({
                                                        address: this.state.properties[index].address,
                                                        currentProperty: index,
                                                        showHmoQuestion: true,
                                                        showTenancyCountQuestion: selectedProperty.tenancyCount > 1,
                                                        showFlatsQuestion: selectedProperty.tenancyCount < 2,
                                                        showFlatsCountQuestion: selectedProperty.numberOfFlats > 1,
                                                        isHmo: selectedProperty.tenancyCount > 1,
                                                        isFlats: selectedProperty.numberOfFlats > 1,
                                                        tenancyCount: selectedProperty.tenancyCount,
                                                        flatsCount: selectedProperty.numberOfFlats,
                                                        showProductsContainer: true,
                                                    });
                                                }}
                                                onCheckout={() => {

                                                    let partialPolicy = this.state.partialPolicy;
                                                    partialPolicy.properties = this.props.basket.properties.filter((e) => e.products);
                                                    partialPolicy.agentCode = this.props.agentCode || "ABIB";
                                                    partialPolicy.fromDate = this.props.startDate;
                                                    if (this.state.showDebug) {
                                                        console.log("PropertyAndCover::partialPolicy", this.state.partialPolicy);
                                                        console.log("PropertyAndCover::policy", this.state.policy);
                                                        console.log("PropertyAndCover::props", this.props);
                                                        console.log("PropertyAndCover::state", this.state);
                                                    }

                                                    var result = this.props.createPolicy(
                                                        partialPolicy,
                                                        this.props.utm == null
                                                            ? {
                                                                campaign: null,
                                                                adgroup: null,
                                                                keyword: null,
                                                                gclid: null,
                                                                fallback: null,
                                                                medium: null,
                                                                source: null,
                                                                agent: (this.props.utm || {campaign: "", content: "", medium: "", source: "", agent: this.props.agentCode || "ABIB"}).agent
                                                            }
                                                            : this.props.utm
                                                    );


                                                }}
                                            />
                                        </Sticky>


                                    </Grid.Column>
                                </Grid.Row>
                            </Ref>
                        </Grid>
                        <Divider hidden/>
                    </Container>
                </Container>
                {this.state.showExclusivityGroupModal ? this.renderExclusitivityGroupCheckModal() : null}
            </>
        );
    }
}

const mapStateToProps = ({
                             basket,
                             startDate,
                             address,
                             products,
                             policyResponse,
                         }: IStoreState): {
    basket: Basket;
    startDate: string;
    address: Address;
    products: IProductState | null;
    policyResponse: IPolicyResponse | null;
} => {
    return {basket, startDate, address, products, policyResponse};
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        addToBasket: (basket: Basket, property: Property, product: Product) => {
            return dispatch(basketActions.addToBasket(basket, property, product));
        },
        removeFromBasket: (basket: Basket, property: Property, product: Product) => {
            return dispatch(basketActions.removeFromBasket(basket, property, product));
        },
        addProperty: (property: Property) => {
            return dispatch(propertiesActions.addProperty(property));
        },
        updateBasket: (basket: Basket, property: Property) => {
            return dispatch(basketActions.updateBasket(basket, property));
        },
        createPolicy: (partialPolicy: PartialPolicy, utm: IUtm) => {
            return dispatch(policyActions.createPolicy(partialPolicy, utm));
        },
    };
};

export const PropertyAndCover = connect(mapStateToProps, mapDispatchToProps)(_PropertyAndCover);
